import React, { useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { getInvitations } from '../../actions/invitationActions';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const InvitationStatusChart = ({ getInvitations, invitations }) => {
  useEffect(() => {
    getInvitations();
  }, [getInvitations]);

  const statusCounts = invitations.reduce((acc, invitation) => {
    acc[invitation.status] = (acc[invitation.status] || 0) + 1;
    return acc;
  }, {});

  const totalInvitations = invitations.length;

  const data = {
    labels: ['Pending', 'Archived'],
    datasets: [
      {
        label: 'Invitations',
        data: [
          statusCounts['pending'] || 0,
          statusCounts['archived'] || 0
        ],
        backgroundColor: [
          '#3b82f6', // blue-500 for pending
          '#6b7280'  // gray-500 for archived
        ],
        borderWidth: 0,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const value = context.raw;
            return `${value} invitation${value !== 1 ? 's' : ''}`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1
        }
      }
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="bg-white rounded-xl shadow p-6 flex flex-col md:flex-row items-center justify-between w-full max-w-2xl mx-auto">
      <div className="flex flex-col items-start mb-4 md:mb-0">
        <span className="text-gray-500 text-sm">Total Invitations</span>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-3xl font-bold text-gray-900">{totalInvitations}</span>
        </div>
      </div>
      <div className="flex items-center gap-8 w-full md:w-auto justify-center">
        <div className="relative w-80 h-40">
          <Bar data={data} options={options} />
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <div className="flex items-center gap-2">
            <span className="inline-block w-3 h-3 rounded-full" style={{ background: '#3b82f6' }}></span>
            <span>Pending</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="inline-block w-3 h-3 rounded-full" style={{ background: '#6b7280' }}></span>
            <span>Archived</span>
          </div>
        </div>
      </div>
    </div>
  );
};

InvitationStatusChart.propTypes = {
  getInvitations: PropTypes.func.isRequired,
  invitations: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
  invitations: state.invitation.invitations
});

export default connect(mapStateToProps, { getInvitations })(InvitationStatusChart); 
